import React from "react";
import { Link } from "react-router-dom";
import logoImg from "images/logo.svg";
import logoLightImg from "images/logo.svg";
import { useData } from "data/data-provider";

export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  img = logoImg,
  imgLight = logoLightImg,
  className = "w-24",
}) => {
  const { companyDetails } = useData();
  return (
    <Link
      to="/"
      className={`ttnc-logo inline-block text-text-color focus:outline-none focus:ring-0`}
    >
      <img width={120} height={60} src={companyDetails?.company_logo} />
    </Link>
  );
};

export default Logo;
